/**
 * Store the invite token before redirecting to signup page.
 */

export default function({ to, from, store }) {
    if (to.name !== 'signup' && !store.getters.apiKey) {
        store.commit('setInviteToken', to.params.token);
        return { name: 'signup' };
    }
}
